import {
  SET_ALL_SECTORS_LIST
} from "./../types";

export default (state = {}, action) => {
  switch(action.type) {
    case SET_ALL_SECTORS_LIST:
      return action.payload
    default:
      return state
  }
}


// WEBPACK FOOTER //
// src/redux/reducers/allSectorsReducer.js